<div class="content-header">{{getSONameBasedOnType()}}</div>
<div class="header-helper">The {{getSONameBasedOnType()}}, also known as the TLD manager, is the legal entity responsible for managing the
  domain in accordance with
  the relevant delegation agreements.
</div>

<div class="content content-with-elevation">
<sponsoring-org-view *ngIf="!editmode" [hasNonTechnicalPermission]="hasNonTechnicalPermission" [lastchange]="lastchange" [organizationVO]="domain?.organization" (edit)="edit($event)" [change]="change" [pendingRequestChangeID]="pendingRequestChangeID" [viewMode]="viewMode"></sponsoring-org-view>
<sponsoring-org-edit *ngIf="editmode"  [organizationVO]="domain?.organization" (sponsoringOrgVOOutput)="sponsoringOrgOutput($event)" (cancelOutPut)="cancel($event)"></sponsoring-org-edit>
</div>
